import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Identity } from '@xanadu/model';
import { map, tap } from 'rxjs/operators';
import { UrlHelper } from '../url-helper';
import { Settings } from '../../../config/settings';
import { AuthSignal } from '@xanadu/signal';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private readonly xanaduIdentity: string = 'xanadu_identity';
    private readonly authSignal = inject(AuthSignal);

    constructor(
        private readonly settings: Settings,
        private readonly http: HttpClient,
        private readonly urlHelper: UrlHelper
    ) {
    }

    public login(email: string, password: string): Observable<Identity | null> {
        return this.http.post<any>(this.urlHelper.of(this.settings.value.urlLogin), { email, password })
            .pipe(
                map(response => {
                    if (!response?.token) {
                        return null;
                    }

                    const identity = new Identity(response.value);
                    identity.token = response.token;

                    return identity;
                }),
                tap(identity => {
                    if (!identity) {
                        return;
                    }

                    sessionStorage.setItem(
                        this.xanaduIdentity,
                        JSON.stringify(identity)
                    );

                    this.authSignal.identity.set(identity);
                })
            );
    }

    public get valid(): boolean {
        if (this.authSignal.identity()) {
            return true;
        }

        const sessionIdentity = sessionStorage.getItem(this.xanaduIdentity);
        if (sessionIdentity?.length) {
            const identity = new Identity(JSON.parse(sessionIdentity));
            this.authSignal.identity.set(identity);
            return true;
        }

        return false;
    }

    public logout() {
        // remove user from local storage to log user out
        sessionStorage.removeItem(this.xanaduIdentity);
        this.authSignal.identity.set(undefined);
    }
}
